<template>

  <div class="welcome-to-origo-component h-100">

    <div class="container h-100">
      <div class="row h-100 align-items-center">
        <div class="col-12">
          <div class="card">
            <div class="row">
              <div class="col-12 col-lg-6 left text-center">

                <h1>{{ heading }}</h1>

                <!-- <validation-observer ref="login-form"> -->
                <form method="POST" action="/api/authenticate" @submit.prevent="login" id="login-form">

                  <!-- <validation-provider v-slot="{ errors, validate, classes, valid }" name="username" rules="required"> -->
                  <div class="input username">
                    <input type="text" class="username" name="username" id="username" v-model="payload.username" autocomplete="off" required>
                    <label for="username"><i class="icon-profile"></i> Username</label>
                  </div>
                  <span v-for="error in errors" :class="classes">{{ error }}</span>
                  <!-- </validation-provider> -->

                  <!-- <validation-provider v-slot="{ errors, validate, classes, valid }" name="username" rules="required"> -->
                  <div class="input password">
                    <input type="password" class="password" id="password" v-model="payload.password" autocomplete="off" required>
                    <label for="password"><i class="icon-password"></i> Password</label>
                  </div>
                  <span v-for="error in errors" :class="classes">{{ error }}</span>
                  <!-- </validation-provider> -->

                  <div v-if="error.error_description !== 'Account Locked.' && error.error === 'invalid_grant'">
                    <p class="inactive"> {{ error.error_description }} </p>
                  </div>

                  <div>
                    <button type="submit" class="button button--steelBlue w-100">{{ buttonText }} <i
                      class="icon-arrow-right"></i></button>
                  </div>

                  <div v-if="error.error_description === 'Account Locked.'">
                    <p class="inactive">{{ passwordResetInactiveAccountWarningLinkText }} - <a
                      :href="'mailto:'+passwordResetInactiveAccountWarningEmailAddress"
                      aria-label="Email VLS">{{ passwordResetInactiveAccountWarningEmailAddress }}</a></p>
                  </div>

                  <div class="mt-auto mb-0">
                    <p>
                      <router-link :to="{name: 'Request Password Reset'}" :title="passwordResetText"
                        :aria-label="passwordResetText">{{ passwordResetText }}
                      </router-link>
                    </p>
                  </div>
                </form>

                <!-- </validation-observer> -->

              </div>
              <div class="col-12 col-lg-6 right text-center">
                <div class="d-flex flex-column h-100 justify-content-center">
                  <div>
                    <i class="logo-icon"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import Vue from 'vue';
import {EventBus} from '@/event-bus.js';
import {notify} from "@kyvg/vue3-notification";

export default {
  data: () => {
    return {
      payload: {
        username: null,
        password: null
      },
      error: {
        error: null,
        error_description: null
      },
      errors: []
    }
  },

  mounted() {
    console.debug('Mounted: login-component');
  },

  computed: {
    usernameValid() {
      return false
    },
    heading() {
      return this.adminPortalData.content ? this.adminPortalData.content.global.login_heading : '';
    },
    buttonText() {
      return this.adminPortalData.content ? this.adminPortalData.content.global.login_button_text : '';
    },
    passwordResetInactiveAccountWarningEmailAddress() {
      return this.adminPortalData.content ? this.adminPortalData.content.global.password_reset_inactive_account_warning_email_address : '';
    },
    passwordResetInactiveAccountWarningLinkText() {
      return this.adminPortalData.content ? this.adminPortalData.content.global.password_reset_inactive_account_warning_link_text : '';
    },
    passwordResetSetYourNewPasswordText() {
      return this.adminPortalData.content ? this.adminPortalData.content.global.password_reset_set_your_new_password_text : '';
    },
    passwordResetText() {
      return this.adminPortalData.content ? this.adminPortalData.content.global.password_reset_text : '';
    },
  },

  methods: {
    async login() {

      EventBus.$emit('loadingTitle', 'Authenticating User');
      EventBus.$emit('loading', true);

      setTimeout(() => {
        EventBus.$emit('loadingTitle', 'Fetching Driver Profile');
      }, 1500);

      this.$http.post('/api/authenticate', this.payload)
        .then(response => {
          if (response.data.error) {
            this.error = response.data.error
            notify({
              group: 'notify',
              type: 'error',
              title: 'Error - Unable to log in',
              text: this.error.error_description ?? this.error
            })
          } else {
            EventBus.$emit('fetchAdminPortalData', true);
            //this.$parent.fetchAdminPortalData();
            this.$router.push({name: response.data.redirect, params: {...this.$route.params}});
          }
        })
        .catch(err => {
          notify({
            group: 'notify',
            type: 'error',
            text: err
          })
        }).finally(() => {
          EventBus.$emit('loading', false);
        });
    },
  },

  props: [
    'session',
    'adminPortalData'
  ]
}
</script>
